define('models/composer/forms/qualityScore/QuestionGroupScore',[
    'lib/knockout',
    'lib/lodash4',
    'util/ObservableModel',
    'models/composer/forms/qualityScore/QuestionScore'
], function (ko, _, ObservableModel, QuestionScoreModel) {
    'use strict';

    //
    // Quality Score Result - Question Group Score Model
    //
    var QuestionGroupScoreModel = ObservableModel.extend({
        defaults: {
            type: 'questionGroupScore',
            questionGroupId: '',
            totalScore: 0,
            maxTotalScore: 0,
            totalCriticalScore: 0,
            maxTotalCriticalScore: 0,
            questionScores: []
        },
        modelProperties: {
            questionScores: QuestionScoreModel
        }
    }, function questionGroupScoreModel_init() {
        var self = this;

        self.modelId = _.uniqueId('questionGroupScore'); //Create an id like "fooXX"
    });

    return QuestionGroupScoreModel;
});
